import { FindingDto } from './finding-dto';
import { ScanModule, ScanType, Severity } from '../enums';

export interface DecaretoFindingDto extends FindingDto {
  scanModule: ScanModule.Decareto;
}

export namespace DecaretoFindingDto {
  export function mapFromApiValue(decaretoFindingDto: any): DecaretoFindingDto {
    return {
      ...decaretoFindingDto,
      scanType: ScanType.mapFromApiValue(decaretoFindingDto.scanType),
      scanModule: ScanModule.Decareto,
      severity: Severity.mapFromApiValue(decaretoFindingDto.severity),
    };
  }
}
